<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" translate>CLOSE</ion-button>
    </ion-buttons>
    <ion-title translate>
      TERMS.TERM
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="legal-content" *ngIf="safe">
  <!-- /embed/ -->

  <!-- <div style="width:100%; height: 100%;">
    <iframe *ngIf="test" [src]="test" width="100%" height="250px"></iframe>
  </div> -->
  
  <!-- <iframe [src]="safe" width="100%" height="250px"></iframe> -->
  <iframe  [src]="safe" width="100%" height="250px"></iframe>
  <iframe  [src]="test" width="100%" height="250px"></iframe>
  

  <!-- webkitallowfullscreen mozallowfullscreen allowfullscreen -->

  <!-- <object [data]="safe" width="100%" height="500px"></object> -->
  <!-- <iframe style="height: 800px;" width="100%"  allow="policies" [src]="safe" frameborder="0"></iframe> -->


  <!-- <iframe src="https://google.com/" width="100%" height="500" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe> -->

  <!-- <iframe style="height: 800px;" width="100%" target="_parent" src="http://localhost:8100/app/home" frameborder="0"></iframe> -->

  <!-- <iframe style="height: max-content;" width="100%" target="_parent" src="https://www.google.com/" frameborder="0"></iframe> -->
  <!-- <iframe style="min-height: 200px; min-width: 200px;" target="_parent" src="/" frameborder="0"></iframe> -->
  <!-- <h3 class="legal-title" translate>TERMS.WELCOME</h3>
  -->
</ion-content>




<!-- /REVISAR
igual y en app no tenemos este problema ?....
https://ionicframework.com/docs/core-concepts/webview
https://fdezromero.com/cors-errors-in-ionic-apps/
https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS
https://ionicframework.com/docs/troubleshooting/cors

https://ionicframework.com/blog/handling-cors-issues-in-ionic/
-->







<!-- 


  CONCLUSION: BUSCAR OTRA ALTERNATIVA QUE NO SEA IFRAME

  -WEBVIEW?
  -INAPPBROWSER? (VER ESTO)

 -->